module.exports = {"513222100":"杂谷脑镇","513222101":"米亚罗镇","513222102":"古尔沟镇","513222103":"薛城镇","513222104":"桃坪镇","513222200":"夹壁乡","513222201":"朴头乡","513222202":"甘堡乡","513222203":"蒲溪乡","513222204":"上孟乡","513222205":"下孟乡","513222206":"木卡乡","513222207":"通化乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513222.json
// module id = 2214
// module chunks = 0